import { isEmptyString } from '@/utils/string';
import { isDynamicSenderUid } from './dynamic-sender-uid';

type DynamicSenderIdentity = { name?: string | null; phone?: string | null };

/**
 * A dynamic sender's label in pickers and previews. Its phone usually holds an
 * internal uid, which is never shown, but a sender moved over during the manual
 * sender migration keeps a real number that tells it apart from its namesakes.
 */
export function dynamicSenderLabel({ name, phone }: DynamicSenderIdentity): string {
  const label = name ?? '';
  if (phone == null || isEmptyString(phone) || isDynamicSenderUid(phone)) return label;
  return isEmptyString(label) ? phone : `${label} <${phone}>`;
}
